import { get } from 'lodash-es'
import { Store } from 'vuex'
import type { AxiosError } from 'axios'
import type { NuxtApp } from 'nuxt/app'
import { Interceptor } from '~/plugins/api/api-factory/interceptors/interceptor'
import { types } from '~/plugins/api/api-factory/interceptors/constants'
import type { IRootState } from '~/store'

export class MissingTokenInterceptor extends Interceptor {
  static TYPE = types.RESPONSE
  static _ERROR_TYPE = 'MISSING_AUTHENTICATION_TOKEN'
  static _ERROR_STATUS = 403

  constructor(
    protected readonly _store: Store<IRootState>,
    protected readonly _nuxtApp: NuxtApp
  ) {
    super()
  }

  onError(error: AxiosError) {
    // TODO: Add logger for errors
    const { _ERROR_STATUS, _ERROR_TYPE } = MissingTokenInterceptor
    const status = get(error, ['response', 'status'], null)
    const errorType = get(error, ['response', 'headers', 'x-ErrorType'], null)

    if (status === _ERROR_STATUS && errorType === _ERROR_TYPE) {
      // Access $auth dynamically from nuxtApp to ensure we get the current auth state
      const auth = this._nuxtApp.$auth
      auth?.refreshTokens().catch(() => {
        this._store.dispatch('user/logout')
      })
    }

    return super.onError(error)
  }
}
